import { H2, H5, P3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Title = styled(H2)`
  text-align: center;
`;

export const TabWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin: 0;

  ${QUERIES.largeTabletAndUp} {
    gap: 24px;
  }
`;

export const ChevronButton = styled.button`
  min-width: 28px;
  border: none;
  background-color: transparent;

  svg {
    transform: rotate(${({ rotateIcon }) => (rotateIcon ? '180deg' : 0)});
  }
`;

export const TabButton = styled.button`
  border-radius: ${themeStyle.radiusMedium};
  padding: 7px 10px 7px 10px;
  background-color: ${({ selected }) =>
    selected ? themeStyle.varInkSuperLight : themeStyle.transparent};
  color: ${({ selected }) =>
    selected ? themeStyle.varInkMain : themeStyle.varInkMedium};
  font-size: ${themeStyle.fontSize12};
  font-weight: ${themeStyle.fontSemiBold};
  border: none;
  flex-grow: 1;
  cursor: pointer;
  transition: all 150ms ease-in;

  ${QUERIES.largeTabletAndUp} {
    flex-grow: initial;
    font-size: ${themeStyle.fontSize14};
  }

  &:hover {
    color: ${themeStyle.varInkMain};
    background-color: ${themeStyle.varInkSuperLight};
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-areas: 'text' 'image' 'button';
  text-align: left;

  ${QUERIES.largeTabletAndUp} {
    display: flex;
    align-items: center;
    gap: 60px;
  }
`;

export const TabTitle = styled(H5)`
  margin-bottom: 12px;
  ${QUERIES.largeTabletAndUp} {
    font-size: 28px;
    line-height: 28px;
    margin-bottom: 24px;
  }
`;

export const Text = styled(P3)`
  margin-top: 24px;
  p {
    margin: 0px;
  }

  ${QUERIES.largeTabletAndUp} {
    font-size: ${themeStyle.fontSize18};
    line-height: 29px;
  }
`;

export const ImageContainer = styled.div`
  grid-area: image;
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  border-radius: ${themeStyle.radiusLarge};
  aspect-ratio: 4/3;

  img,
  video {
    display: block;
    width: 100%;
    height: 100%;
    border: 4px solid #ffffff;
    border-radius: ${themeStyle.radiusLarge};
    box-shadow: ${themeStyle.varShadowSoft};
    overflow: hidden;

    ${QUERIES.largeTabletAndUp} {
      border: 10px solid ${themeStyle.inkBase};
    }
  }
`;
